<template>
  <div class="intro-animation">
    <img
      :src="src"
      alt=""
      class="image"
      draggable="false"
    />
  </div>
</template>

<script>
import { TweenMax } from 'gsap'
import windowUtil from '@/utils/window'

export default {
  name: 'IntroAnimation',
  data () {
    return {
      src: require('@/assets/images/intro-sequence/1.png'),
      images: [{
        trigger: 40,
        src: require('@/assets/images/intro-sequence/1.png')
      }, {
        trigger: 80,
        src: require('@/assets/images/intro-sequence/2.png')
      }, {
        trigger: 120,
        src: require('@/assets/images/intro-sequence/3.png')
      }, {
        trigger: 160,
        src: require('@/assets/images/intro-sequence/4.png')
      }, {
        trigger: 200,
        src: require('@/assets/images/intro-sequence/5.png')
      }, {
        trigger: 240,
        src: require('@/assets/images/intro-sequence/6.png')
      }, {
        trigger: 280,
        src: require('@/assets/images/intro-sequence/7.png')
      }, {
        trigger: 300,
        src: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
      }]
    }
  },
  mounted () {
    windowUtil.addScrollListener(this.onScroll, 100)

    const scene = this.$scrollmagic.scene({
      triggerHook: 'onLeave',
      duration: '100%'
    })

    this.$scrollmagic.addScene(
      scene.setTween(TweenMax.to('.intro-animation', 1, {
        y: '100%'
      }))
    )
  },
  methods: {
    onScroll () {
      const images = this.images.filter(img => img.trigger >= windowUtil.scrollFromTop).map(img => img.src)
      this.src = images.length ? images[0] : this.images[this.images.length - 1].src
    }
  }
}
</script>

<style lang="scss" scoped>
.intro-animation {
  padding-bottom: 36px;
}

.image {
  width: 125px;
  height: 216px;
}
</style>
